import { render, staticRenderFns } from "./ImagesList.vue?vue&type=template&id=bc5b5968&scoped=true&"
import script from "./ImagesList.vue?vue&type=script&lang=js&"
export * from "./ImagesList.vue?vue&type=script&lang=js&"
import style0 from "./ImagesList.vue?vue&type=style&index=0&id=bc5b5968&prod&scoped=true&lang=css&"
import style1 from "./ImagesList.vue?vue&type=style&index=1&id=bc5b5968&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5b5968",
  null
  
)

export default component.exports